module.exports = __webpack_public_path__ + "img/product-placeholder.318f38f9.png";